import { useState, useCallback } from "react";
import { useCurrentTime } from "src/business-types/laundry/modules/home/Payment/hooks/useCurrentTime";

export const usePayment = (finalAmount: number = 0) => {
  const [receivedAmount, setReceivedAmount] = useState<number>(0);
  const [remainingAmount, setRemainingAmount] = useState<number>(finalAmount);
  const [showBalance, setShowBalance] = useState<boolean>(false);
  const { currentTime } = useCurrentTime();

  const handleReceivedAmountChange = useCallback(
    (value: number) => {
      setReceivedAmount(value);
      setRemainingAmount(finalAmount - value);
    },
    [finalAmount]
  );

  const toggleShowBalance = useCallback(() => {
    setShowBalance((prev) => !prev);
  }, []);

  const roundAmount = useCallback((value: number | string): string => {
    const num = Number(value);
    if (isNaN(num)) return "0.00";
    return (Math.round(num * 100) / 100).toFixed(2);
  }, []);

  const resetPayment = useCallback(() => {
    setReceivedAmount(0);
    setRemainingAmount(finalAmount);
    setShowBalance(false);
  }, [finalAmount]);

  return {
    receivedAmount,
    remainingAmount,
    showBalance,
    currentTime,
    handleReceivedAmountChange,
    toggleShowBalance,
    roundAmount,
    resetPayment,
  };
};
